import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as actionsCategory from '../../category/redux/actions';
import * as actionsEvent from '../../event/redux/actions';
import { Row, Spin, Col, Input, Select, DatePicker, TimePicker, Checkbox, Modal, Button, Tag, Form, InputNumber, Switch, Icon} from 'antd';
import moment from 'moment';
import UploadImage from './UploadImage';
import API from '../../../helper/api/Api';
import { EVENT, MOMENT, roleOptions } from './Constants';
import ItemDescription from '../../event/ItemDescription';
import _ from 'lodash';
import SearchBox from '../../../helper/map/searchBox';
import Map from '../../../helper/map/map';
import TextEditor from '../TextEditor';
import * as actionsAdmin from "../redux/actions"; 

const { TextArea } = Input;

export class FormEvent extends Component {
  static propTypes = {
    loading: PropTypes.bool,
    event: PropTypes.object
  };

  static defaultProps = {
    loading: false,
    event: EVENT()
  }

  getRoleOption = (id) => this.priceOptions().filter(r => r.id === Number(id))[0] || {color: "grey", name: "na"}

  getLastRole = (options = roleOptions(this.props.ROLE_ID), props = this.props) => {
    const roles = options.filter(r => !props.prices.map(p => p.role).includes(r.id) && r.id !== 0)

    return roles.length > 0 ? roles[0].id : null;
  }

  priceOptions = (props = this.props) => [
    {id: 0, name: "Prix commun", color: "volcano"},
    ...roleOptions(props.ROLE_ID)
  ]

  //STATE
  state = {
    maps: null,
    priceId: 0,
    amount: null,
    moderator: {
      users: [],
      isFetching: false
    },
    category: {
      list: []
    }
  }

  parsePrice = (role = null) => ({ amount: this.state.amount, role: Number(role || this.state.priceId) })

  isPriceAll = () => {
    if(this.props.prices.length >= (this.priceOptions().length - 1))
      return Object.keys(_.groupBy(this.props.prices, 'amount')).length === 1;

    return false;
  }

  getDate(value) {
    return this.props.event[value] ? moment(this.props.event[value]) : null;
  }

  componentWillMount() {
    //getRole if empty
    if(this.props.ROLE_ID.ADMIN === 0 
      || this.props.ROLE_ID.MODERATOR === 0
      || this.props.ROLE_ID.STUDENT === 0)
      this.props.actions.getRoles();

    this.props.actions.getCategories();
  }

  componentWillReceiveProps(props) {
    if(this.props.prices.length !== props.prices.length || this.props.ROLE_ID !== props.ROLE_ID)
        this.setState({ priceId: this.getLastRole(this.priceOptions(props), props)})
  }

  //helper to change a event
  setEvent(value) {
    return this.props.onEventChange(value);
  }

  //date change
  disabledDate = (start, end, inverse = false) => {
    if (!start || !end)
      return false;

    if (inverse)
      return end.format('YYYYMMDD') < start.format('YYYYMMDD');

    return start.format('YYYYMMDD') > end.format('YYYYMMDD');
  }

  handleDate(value, date, isTime = false) {
    let _date = null;
    const _dateProps = this.getDate(value);
    const _dateMoment = date;

    if (!_dateProps)
      _date = date;
    else if (isTime)
      _date = _dateProps.hours(_dateMoment.hours()).minutes(_dateMoment.minutes());
    else
      _date = _dateMoment.hours(_dateProps.hours()).minutes(_dateProps.minutes());

    this.setEvent({ [value]: _date });
  }

  render() {
    const restrictedRoles = this.props.event.restrictedRoles ? this.props.event.restrictedRoles.map(r => r.roleId ) : [];
    const loading = this.props.loading || this.props.admin.status.getRoles.pending;
    const priceOptions = this.priceOptions();
    const priceId = this.state.priceId;
    
    return (
      // *****
      //open/close -> event 
      //start/end -> inscription
      // *****

      <div style={{ marginTop: '10px' }}>


        {/* EVENEMENT  */}
        <Row>
          <Col className="bloc-admin" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 9 }} xl={{ span: 9 }} >
            <Spin size="small" spinning={loading}>
              <Row>
                <h2 style={{ textTransform: 'uppercase' }}>événement</h2>
              </Row>
              <Row>
                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} style={{ padding: '5px 0 0 5px' }} >
                  <Input
                    placeholder="Nom de l'événement"
                    value={this.props.event.title}
                    onChange={(e) => this.setEvent({ title: e.target.value })}
                  />
                </Col>
                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} style={{ padding: '5px 0 0 5px' }}>
                  <Select
                    showSearch
                    mode="multiple"
                    placeholder="Selectionner une catégorie"
                    value={this.props.event.eventCategory}
                    onSelect={(category) => this.props.id ? API.get('/event/' + this.props.id + '/category/' + category) : null}
                    onDeselect={(category) => this.props.id ? API.delete('/event/' + this.props.id + '/category/' + category) : null}
                    onChange={(category) => this.setEvent({ eventCategory: category })}
                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                    style={{ display: 'block' }}
                  >
                    {
                      _.sortBy(this.props.category.list, ['name']).map(items => {
                        return <Select.Option value={items.id} key={items.id} >{items.name}</Select.Option>
                      })
                    }
                  </Select>
                </Col>
              </Row>
            </Spin>
          </Col>

          {/* MODERATEUR  */}

          <Col className="bloc-admin" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 8 }} xl={{ span: 8 }} >
            <Spin size="small" spinning={loading}>
              <Row>
                <h2>MODÉRATEUR</h2>
              </Row>
              <Row>
                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 16 }} style={{ padding: '5px 0 0 5px' }}>
                  <Select
                    mode="multiple"
                    labelInValue
                    value={this.props.moderators}
                    placeholder="Séléctionner un modérateur"
                    onSelect={(moderator) => this.props.addModerator ? this.props.addModerator(moderator) : null}
                    onDeselect={(moderator) => this.props.removeModerator ? this.props.removeModerator(moderator) : null}
                    notFoundContent={this.state.isFetching ? <Spin size="small" /> : null}
                    filterOption={false}
                    onSearch={(search) => {
                      this.setState({ moderator: { ...this.state.moderator, users: [], isFetching: true } })
                      API.get('/user/all', { search, staff: 'True' })
                        .then((res) => this.setState({ moderator: { ...this.state.moderator, users: res.data, isFetching: false } }))
                        .catch((e) => this.setState({ moderator: { ...this.state.moderator, users: [], isFetching: false } }))
                    }}
                    onChange={(moderators) => {
                      if(this.props.onModeratorChange)
                        this.props.onModeratorChange(moderators)
                      this.setState({ moderator: { ...this.state.moderator, users: [] } })
                    }}
                    style={{ width: '100%' }}
                  >
                    {this.state.moderator.users.filter(u => !this.props.moderators.map(m => m.key).includes(u.id)).map(u => <Select.Option key={u.id}>{u.firstName} {u.lastName.toUpperCase()}</Select.Option>)}
                  </Select>
                </Col>
                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 8 }} style={{ padding: '5px 0 0 5px' }}>
                  <InputNumber
                    placeholder="Point jury"
                    step={0.01}
                    defaultValue={0}
                    value={this.props.event.juryPoint || 0}
                    style={{ width: '100%' }}
                    min={0}
                    max={5}
                    formatter={value => `${value} points jury`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    parser={value => value.replace(/\s\points jury?|(,*)/g, '')}
                    onChange={ (juryPoint) => this.setEvent({ juryPoint })}
                  />
                </Col>
              </Row>
            </Spin>
          </Col>

          {/* Restriction  */}
          <Col className="bloc-admin" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 6 }} xl={{ span: 6}} >
            <Spin size="small" spinning={loading}>
              <Row>
                <Row type="flex" justify="space-between">
                    <Col span={20}>
                      <h2>RESTRICTIONS</h2>
                    </Col>
                    <Col span={4}>
                      <Switch 
                        checkedChildren={<Icon type="lock" />}
                        unCheckedChildren={<Icon type="unlock" />}
                        checked={this.props.event.restrictedEvent} 
                        onChange={(restrictedEvent) => this.setEvent({ restrictedEvent })}/>
                    </Col>
                </Row>
              </Row>
              <Row>
                <Col style={{ padding: '5px 0 0 5px' }}>
                  <Select
                    mode="multiple"
                    style={{width: '100%'}}
                    placeholder="Séléctionner un rôle à restreindre"
                    disabled={ !this.props.event.restrictedEvent }
                    value={ this.props.event.restrictedRolesList || restrictedRoles || [] }
                    onChange={(restrictedRolesList) => this.setEvent({ restrictedRolesList, restrictedRolesChange: true })}>
                    { roleOptions(this.props.ROLE_ID).map(s => <Select.Option value={s.id}>{s.name}</Select.Option> ) }
                  </Select>
                </Col>
              </Row>
            </Spin>
          </Col>
        </Row>

        {/* DATE  */}

        <Row>
          <Col className="bloc-admin" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 6 }} xl={{ span: 6 }}>
            <Spin size="small" spinning={loading}>
              <Row>
                <h2>DATES</h2>
              </Row>
              <Row style={{ margin: '10px 0 10px 0' }}>
                <Row>
                  Commence le *
                  </Row>
                <Row>
                  <DatePicker
                    disabledDate={(date) => this.disabledDate(date, this.getDate("closeAt"))}
                    format={MOMENT.DATE}
                    value={this.getDate("openAt")}
                    defaultValue={moment(moment().format('YYYY-MM-DD'), 'YYYY-MM-DD')}
                    onChange={(date) => this.handleDate("openAt", moment(date.format('YYYY-MM-DD'), 'YYYY-MM-DD'))}
                    style={{ width: '100%' }}
                  />
                </Row>
              </Row>
              <Row style={{ margin: '10px 0 10px 0' }}>
                <Row>
                  à *
                  </Row>
                <Row>
                  <TimePicker
                    format={MOMENT.TIME}
                    value={this.getDate("openAt")}
                    defaultValue={moment('00:00', 'HH:mm')}
                    onChange={(time) => this.handleDate("openAt", time, true)} />
                </Row>
              </Row>
              <Row style={{ margin: '10px 0 10px 0' }}>
                <Row>
                  termine le *
                  </Row>
                <Row>
                  <DatePicker
                    disabledDate={(date) => this.disabledDate(this.getDate("openAt"), date, true)}
                    format={MOMENT.DATE}
                    value={this.getDate("closeAt")}
                    defaultValue={moment(moment().format('YYYY-MM-DD'), 'YYYY-MM-DD')}
                    onChange={(date) => this.handleDate("closeAt", moment(date.format('YYYY-MM-DD'), 'YYYY-MM-DD'))}
                    style={{ width: '100%' }}
                  />
                </Row>
              </Row>
              <Row style={{ margin: '10px 0 10px 0' }}>
                <Row>
                  à *
                  </Row>
                <Row>
                  <TimePicker
                    format={MOMENT.TIME}
                    defaultValue={moment('00:00', 'HH:mm')}
                    value={this.getDate("closeAt")}
                    onChange={(time) => this.handleDate("closeAt", time, true)}
                  />
                </Row>
              </Row>
            </Spin>
          </Col>

          {/* DESCRIPTION  */}

          <Col className="bloc-admin" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 17 }} xl={{ span: 17 }}>
            <Spin size="small" spinning={loading}>
              <Row>
                <h2>DESCRIPTION</h2>
              </Row>
              <Row style={{ margin: '8px 0 0 0' }}>
                {loading ? 
                  <p style={{height: 240}}></p>
                  :
                  <TextEditor
                  value={ this.props.event.description } 
                  onChange={(value) => this.setEvent({ description: value })}
                  />
                }
              </Row>
            </Spin>
          </Col>
        </Row>

        {/* INSCRIPTION  */}

        <Row>
          <Col style={{ margin: '0 10px 0 0' }} xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 8 }} xl={{ span: 8 }}>
            <Col className="bloc-admin" xs={{ span: 24 }}>
              <Spin size="small" spinning={loading}>
                <Row type="flex" justify="space-between">
                  <Col span={21}>
                    <h2>INSCRIPTION</h2>
                  </Col>
                  <Col span={3}>
                    <Switch 
                      checkedChildren={<Icon type="check" />}
                      unCheckedChildren={<Icon type="close" />}
                      checked={!this.props.event.noRegistration} 
                      onChange={(noRegistration) => this.setEvent({ noRegistration: !noRegistration })}/>
                  </Col>
                </Row>
                <Col style={{ margin: '10px 0 10px 0' }} xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }} xl={{ span: 12 }}>
                  <Row>
                    Ouverture le *
              </Row>
                  <Row>
                    <DatePicker
                      showTime={{ defaultValue: moment('00:00:00', 'HH:mm:ss') }}
                      disabledDate={(date) => this.disabledDate(date, this.getDate("endAt"))}
                      disabled={this.props.event.noRegistration}
                      value={this.getDate("startAt")}
                      format={this.props.event.startAt && this.getDate("startAt").format('HH:mm') === "00:00" ? "Do MMMM YYYY" : "Do MMMM YYYY à HH:mm"}
                      onChange={(date) => this.setEvent({ startAt: date })}
                      style={{ width: '100%' }}
                    />
                  </Row>
                </Col>
                <Col style={{ margin: '10px 0 10px 0' }} xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }} xl={{ span: 12 }}>
                  <Row>
                    Fermeture le *
                  </Row>
                  <Row>
                    <DatePicker
                      showTime={{ defaultValue: moment('00:00:00', 'HH:mm:ss') }}
                      disabledDate={(date) => this.disabledDate(this.getDate("startAt"), date, true)}
                      disabled={this.props.event.noRegistration}
                      format={this.props.event.endAt && this.getDate("endAt").format('HH:mm') === "00:00" ? "Do MMMM YYYY" : "Do MMMM YYYY à HH:mm"}
                      value={this.getDate("endAt")}
                      onChange={(date) => this.setEvent({ endAt: date })}
                      style={{ width: '100%' }}
                    />
                  </Row>
                </Col>
                <Col style={{ margin: '10px 0 10px 0' }} xs={{ span: 24 }} >
                  <Row>
                    Nombre maximum de places
                  </Row>
                  <Row>
                    <Input
                      placeholder="Nombre"
                      type="number"
                      value={this.props.event.subscribeNumber === 0 ? null : this.props.event.subscribeNumber}
                      disabled={this.props.event.noRegistration}
                      onKeyPress={(event) => event.charCode >= 48 && event.charCode <= 57}
                      onChange={(e) => this.setEvent({ subscribeNumber: Number(e.target.value) })}
                    />
                  </Row>
                </Col>
                <Col style={{ margin: '5px 0 0 0' }} xs={{ span: 24 }} >
                  <Row>
                    <Checkbox checked={this.props.event.validationRequired} disabled={this.props.event.noRegistration} onChange={(e) => this.setEvent({ validationRequired: e.target.checked })}>Validation des inscriptions</Checkbox>
                  </Row>
                </Col>
              </Spin>
            </Col>

            {/* UPLOAD  */}

            <Col className="bloc-admin" xs={{ span: 24 }}>
              <Spin size="small" spinning={loading}>
                <UploadImage
                  id={this.props.id || 0}
                  files={this.props.files}
                  onChange={(file) => this.props.addFile(file)}
                  onRemove={(file) => this.props.removeFile(file)}
                />
              </Spin>
            </Col>

            {/* PRIX  */}
            <Col className="bloc-admin" xs={{ span: 24 }}>
              <Spin size="small" spinning={loading}>
                { this.props.prices.length < (priceOptions.length - 1) ? 
                  <Form layout="inline" onSubmit={(e) => {
                    e.preventDefault();
                    if(this.state.amount && this.props.prices.filter(r => r.role === priceId).length === 0){
                      if(priceId === 0) {
                        this.props.prices.map(price => this.props.removePrice(price))
                        for(const role of priceOptions.filter(r => r.id !== 0))
                          this.props.addPrice(this.parsePrice(role.id));
                      }
                      else
                        this.props.addPrice(this.parsePrice());

                      this.setState({ amount: null })
                    }
                  }}>
                    <Form.Item>
                      <InputNumber
                        placeholder="Prix"
                        style={{width: 150}}
                        step={0.1}
                        min={0}
                        formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        parser={value => value.replace(/\€\s?|(,*)/g, '')}
                        onChange={ (amount) => this.setState({ amount })}
                      />
                    </Form.Item>
                    <Form.Item>
                      <Select defaultValue={ this.getLastRole(priceOptions) } value={ priceId } onChange={(price) => this.setState({ priceId : price })}>
                        <Select.OptGroup label="Global">
                          <Select.Option value={priceOptions[0].id}>{priceOptions[0].name}</Select.Option>
                        </Select.OptGroup>
                        <Select.OptGroup label="Spécifique">
                          { priceOptions.filter(r => !this.props.prices.map(p => p.role).includes(r.id) && r.id !== 0).map(s => <Select.Option value={s.id}>{s.name}</Select.Option> ) }
                        </Select.OptGroup>
                      </Select>
                    </Form.Item>
                    <Form.Item>
                        <Button 
                          type="primary"
                          icon="check"
                          htmlType="submit"
                          disabled={!(this.state.amount && this.props.prices.filter(r => r.role === priceId).length === 0)}
                        />
                    </Form.Item>
                  </Form>
                : ''}
                <Col xs={{ span: 24 }}>
                  { this.isPriceAll() ?
                      <Tag 
                        style={{marginTop: 5}} 
                        closable
                        onClose={() => this.props.prices.map(price => this.props.removePrice(price))}
                        key="All"
                        color={this.getRoleOption(0).color}>
                        {this.getRoleOption(0).name} - {this.props.prices[0].amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} €
                      </Tag>
                      : 
                      _.orderBy(this.props.prices, 'role', 'desc').map(price => {
                        const role = this.getRoleOption(price.role);
                        return <Tag 
                          style={{marginTop: 5}} 
                          closable
                          onClose={() => this.props.removePrice(price)}
                          key={price.role}
                          color={role.color}>
                          {role.name} - {price.amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} €
                        </Tag>
                      })}
                </Col>
              </Spin>
            </Col>
          </Col>

          {/* EMPLACEMENT  */}

          <Col className="bloc-admin" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 15 }} xl={{ span: 15 }}>
            <Spin size="small" spinning={loading}>
              <Row type="flex" justify="space-between">
                  <Col span={22}>
                    <h2>EMPLACEMENT</h2>
                  </Col>
                  <Col span={2} style={{paddingLeft: 15}}>
                    <Switch 
                      checkedChildren={<Icon type="check" />}
                      unCheckedChildren={<Icon type="close" />}
                      checked={!this.props.event.noLocation} 
                      onChange={(noLocation) => this.setEvent({ noLocation: !noLocation })}/>
                  </Col>
                </Row>
                <Row xs={{ span: 24 }} style={{ margin: '10px 0 10px 0' }}>
                    <SearchBox 
                        location={ this.props.event.location }
                        maps={this.state.maps}
                        disabled={this.props.event.noLocation}
                        onPlacesChanged = {(location) => this.setEvent({ location })}
                    />
                </Row>
                <Row>
                    <Col style={{padding: "0 3px", height: 380}}>
                        <Map
                          location = { this.props.event.location }
                          disabled={this.props.event.noLocation}
                          onGoogleApiLoaded={({ map, maps }) => this.setState({ maps })}
                        />
                    </Col>
                </Row>
            </Spin>
        </Col>

          <Modal
            className="modal-event"
            visible={this.props.preview}
            onOk={() => this.props.closePreview()}
            onCancel={() => this.props.closePreview()}
          >
            <ItemDescription id={ this.props.event.id } item={{ event: this.props.event }} categories={this.props.category.list} files={this.props.files} />
          </Modal>
        </Row>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    category: state.category,
    ROLE_ID: state.admin.ROLE_ID,
    admin: state.admin
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actionsCategory, ...actionsEvent, ...actionsAdmin }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FormEvent);


// WEBPACK FOOTER //
// ./src/features/admin/events/Form.js